/**
 * Config — Admin Analytics React (apps/admin-analytics).
 * Backend: gas/analytics-api. Auth: Firebase website-9efa7.
 */
export const ANALYTICS_CONFIG = {
  scriptUrl:
    'https://script.google.com/macros/s/AKfycbxonBhu_7Z2BOsSWO67skvWfEoFYU-VG1n03P20JabyolYRLncFDdeQS2eIzWBKjUfOrw/exec',
  bootstrapMode: false,
  turnstileSiteKey: '0x4AAAAAADKIeoLwkcxA7Zt0',
  turnstileScriptUrl: 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit',
  portalUrl: 'https://portal.gicapital.cl/app.html',
  analyticsOrigin: 'https://analytics.gicapital.cl',
  /** Lectura Meta / export Instant Forms: gicapital-api (sin token Meta en el front). */
  apiBase: 'https://api.gicapital.cl',
  /** Default liviano: la búsqueda es manual (Buscar); 30d se elige a propósito. */
  defaultPeriod: 'last_7_days',
  /** Solo presentación — Abrir lead en Kommo (fuente de datos técnica). */
  kommoLeadUrlTemplate: 'https://giselladittamo.kommo.com/leads/detail/{id}',
  attentionPreviewSize: 15
};

export const PERIOD_OPTIONS = [
  { key: 'all', label: 'Todos' },
  { key: 'today', label: 'Hoy' },
  { key: 'yesterday', label: 'Ayer' },
  { key: 'last_7_days', label: 'Últimos 7 días' },
  { key: 'last_30_days', label: 'Últimos 30 días' },
  { key: 'current_month', label: 'Este mes' },
  { key: 'previous_month', label: 'Mes anterior' }
];

/** Desde histórico amplio para «Completo» (espejo Kommo + Meta). */
export const PERIOD_ALL_FROM = '2020-01-01';

/** @returns {{dateFrom:string, dateTo:string}} */
export function resolvePeriodRange(periodKey) {
  const key = periodKey || ANALYTICS_CONFIG.defaultPeriod;
  const now = new Date();
  const ymd = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  };
  const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const end = startOfDay(now);
  let start = startOfDay(now);

  if (key === 'all') {
    return { dateFrom: PERIOD_ALL_FROM, dateTo: ymd(end) };
  } else if (key === 'today') {
    start = startOfDay(now);
  } else if (key === 'yesterday') {
    const y = startOfDay(new Date(now.getTime() - 86400000));
    return { dateFrom: ymd(y), dateTo: ymd(y) };
  } else if (key === 'last_7_days') {
    start = startOfDay(new Date(now.getTime() - 6 * 86400000));
  } else if (key === 'last_30_days') {
    start = startOfDay(new Date(now.getTime() - 29 * 86400000));
  } else if (key === 'current_month') {
    start = new Date(now.getFullYear(), now.getMonth(), 1);
  } else if (key === 'previous_month') {
    start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const lastPrev = new Date(now.getFullYear(), now.getMonth(), 0);
    return { dateFrom: ymd(start), dateTo: ymd(lastPrev) };
  }

  return { dateFrom: ymd(start), dateTo: ymd(end) };
}
